var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"before-after-page__categories-item",attrs:{"to":{
    name: 'before-after-category',
    params: { category: _vm.category.slug },
  }}},[_c('h3',{staticClass:"before-after-page__categories-item--title"},[_vm._v(" "+_vm._s(_vm.category.name)+" ")]),_c('div',{staticClass:"before-after-page__categories-item--image"},[_c('img',{attrs:{"src":_vm.category.image,"alt":_vm.category.name}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }